import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import BlurModal from '../../../components/common/blur-modal';
import Loading from '../../../components/common/loading/loading-circle';

class AcceptSignConfirmModal extends PureComponent {
  constructor() {
    super();
    this.state = {

    };
  }

  render() {
    const {
      i18n: { messages },
      title,
      confirmationString,
      onClose,
      onConfirm,
      acceptsign: {
        showLoadingForConfirmModal,
        actionAcceptResponseError,
      },
    } = this.props;

    let headerString;
    if (showLoadingForConfirmModal) {
      headerString = '';
    } else {
      headerString = confirmationString;
    }

    return (
      <BlurModal
        visible
        onDone={onClose}
        title={title}
        headerChildren={
          <Text secondary>
            {actionAcceptResponseError || headerString}
          </Text>
        }
        disableOutsideClick={showLoadingForConfirmModal}
      >
        {actionAcceptResponseError !== "" &&
          <div className="row padding-top-50">
            <div className="columns large-3 large-push-9 medium-3 medium-push-9 small-push-9 small-3">
              <Button fullWidth onPress={onClose}>
                {messages['app.rmcallback.okMsg']}
              </Button>
            </div>
          </div>
        }
        {showLoadingForConfirmModal &&
          <div className="padding-top-50 padding-bottom-50">
            <Loading />
            <Text className="center-content" secondary> {messages['app.docusign.digisign.processinfo']}</Text>
          </div>
        }
        {!showLoadingForConfirmModal && !actionAcceptResponseError &&
          <div className="row padding-top-50">
            <div className="columns large-3 large-push-6 medium-3 medium-push-6 small-6">
              {showLoadingForConfirmModal ?
                <Button disabled tertiary fullWidth onPress={onClose}>
                  {messages['app.docsign.esignAcceptance.noButton']}
                </Button>
                :
                <Button tertiary fullWidth onPress={onClose} >
                  {messages['app.docsign.esignAcceptance.noButton']}
                </Button>
              }
            </div>
            <div className="columns large-3 medium-3 small-6">
              <Button fullWidth onPress={onConfirm} loading={showLoadingForConfirmModal}>
                {messages['app.docsign.esignAcceptance.yesButton']}
              </Button>
            </div>
          </div>
        }
      </BlurModal>
    )
  }
}

AcceptSignConfirmModal.propTypes = {
  title: PropTypes.string,
  confirmationString: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};

AcceptSignConfirmModal.defaultProps = {
  title: 'Confirmation Modal',
  confirmationString: 'Are you Sure?',
  onClose: () => { },
  onConfirm: () => { }
};



export default createContainer({
  $queries: {
    i18n: { messages: true },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        },
      }
    },
    acceptsign: {
      showLoadingForConfirmModal: true,
      actionAcceptResponseError: true,
    },
  },
})(AcceptSignConfirmModal);
